import { createAsyncThunk } from '@reduxjs/toolkit';
const BASE_URL = `${process.env.REACT_APP_API_URL}/deliveries`;
const request = async (path, options, signal) => {
  const response = await fetch(`${BASE_URL}${path}`, { ...options, signal });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Unable to load or save the delivery.');
  return data;
};
const action = (name, run) => createAsyncThunk(`deliveries/${name}`, async (args, { signal, rejectWithValue }) => {
  try { return await run(args, signal); }
  catch (error) { return rejectWithValue(error.message || 'Delivery request failed.'); }
});
export const fetchDeliveries = action('fetchList', (date, signal) => request(`?date=${encodeURIComponent(date)}`, {}, signal));
export const fetchDelivery = action('fetchById', (id, signal) => request(`/${id}`, {}, signal));
export const createDelivery = action('create', (payload, signal) => request('', {
  method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
}, signal));
export const saveDelivery = action('save', ({ id, payload }, signal) => request(`/${id}`, {
  method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
}, signal));
export const uploadDeliveryAttachment = action('uploadAttachment', ({ id, file }, signal) => {
  const body = new FormData();
  body.append('photo', file);
  return request(`/${id}/attachments`, { method: 'POST', body }, signal);
});
